import React from "react";
import "../../HowItWorks/CallToActionSection/CallToActionSection.css"

const CallToActionSection = () => {
  return (
    <section className="_cTASectCont_x1A_">
      <div className="_cTASectContent_y2B_">
        <h2 className=" _hTitle_s5E_ features-title" style={{marginBottomBottom:"20rem"}}>
          Questions about your SoW or Support Model?
        </h2>
        <p
          className=" workflow-subtitle _hSubtitle_t6F1_  "
          style={{ paddingTop: "0px", marginTop: "0px",paddingBottom: "0px", marginBottom: "2rem", width:"100%",paddingLeft:"0",paddingRight:"0" }}
        >
          Connect with our team to request a sample SoW, review your current
          agreement, or discuss our partner support approach.
        </p>
        <div className="_cTAButtonsWrapper_b5E_">
          <a href="/contact" className="_cTAButton_c6F_ _devotee_d7G_">
          Contact Us
          </a>
        
        </div>
      </div>
    </section>
  );
};

export default CallToActionSection;
